module.exports = __webpack_public_path__ + "img/undraw_account_490v.908a6c51.svg";